import {
    EyeOutlined,
    CheckOutlined,
    CloseOutlined,
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    EnvironmentOutlined,
    ArrowLeftOutlined,
    LockOutlined,
    UploadOutlined,
    DownOutlined,
    UpOutlined,
    UsergroupAddOutlined,
    HomeOutlined,
    SettingOutlined,
    LogoutOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    PlusOutlined,
    MinusOutlined,
    EditOutlined,
    DeleteOutlined,
    SearchOutlined,
    FilterOutlined,
    ReloadOutlined,
    FileOutlined,
    FolderOutlined,
    CameraOutlined,
    PictureOutlined,
    InfoCircleOutlined,
    WarningOutlined,
    ExclamationCircleOutlined,
    BellOutlined,
    CalendarOutlined,
    ClockCircleOutlined,
    CaretRightOutlined,
} from "@ant-design/icons";
import Icon from "@ant-design/icons";

const Play = ({ size = 24 }) => (
    <span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-play-icon lucide-play"
        >
            <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
        </svg>
    </span>
);
const PlayOff = ({ size = 24 }) => (
    <span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-play-off-icon lucide-play-off"
        >
            <path d="m10.215 4.56 9.79 5.71a2 2 0 0 1 .003 3.458l-.393.23" />
            <path d="m16.042 16.042-8.034 4.686A2 2 0 0 1 5 19V5" />
            <path d="m2 2 20 20" />
        </svg>
    </span>
);
const Pause = ({ size = 24 }) => (
    <span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-pause-icon lucide-pause"
        >
            <rect x="14" y="3" width="5" height="18" rx="1" />
            <rect x="5" y="3" width="5" height="18" rx="1" />
        </svg>
    </span>
);

/** Autoplay — clockwise rotate-arrow with a play triangle (Lucide style). */
const Autoplay = ({ size = 24 }) => (
    <span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide"
        >
            <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
            <polyline points="21 3 21 9 15 9" />
            <path d="m10 9 4 3-4 3z" />
        </svg>
    </span>
);

/** Replay — counter-clockwise rotate-arrow with a play triangle (Lucide style). */
const Replay = ({ size = 24 }) => (
    <span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide"
        >
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <polyline points="3 3 3 9 9 9" />
            <path d="m10 9 4 3-4 3z" />
        </svg>
    </span>
);
const Bell = ({ size = 24 }) => (
    <span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-bell-icon lucide-bell"
        >
            <path d="M10.268 21a2 2 0 0 0 3.464 0" />
            <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
        </svg>
    </span>
);
const LayoutDashboardSvg = () => (
    <svg
        viewBox="0 0 24 24"
        width={"1rem"}
        height={"1rem"}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect width="7" height="9" x="3" y="3" rx="1" />
        <rect width="7" height="5" x="14" y="3" rx="1" />
        <rect width="7" height="9" x="14" y="12" rx="1" />
        <rect width="7" height="5" x="3" y="16" rx="1" />
    </svg>
);
const LayoutTemplateSvg = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        width={"1rem"}
        height={"1rem"}
    >
        <rect width="18" height="7" x="3" y="3" rx="1" />
        <rect width="9" height="7" x="3" y="14" rx="1" />
        <rect width="5" height="7" x="16" y="14" rx="1" />
    </svg>
);

const History = ({ size = 24 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-history-icon lucide-history"
        >
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
            <path d="M3 3v5h5" />
            <path d="M12 7v5l4 2" />
        </svg>
    );
};

const GitCompareArrow = ({ size = 24 }) => {
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-git-compare-arrows-icon lucide-git-compare-arrows"
    >
        <circle cx="5" cy="6" r="3" />
        <path d="M12 6h5a2 2 0 0 1 2 2v7" />
        <path d="m15 9-3-3 3-3" />
        <circle cx="19" cy="18" r="3" />
        <path d="M12 18H7a2 2 0 0 1-2-2V9" />
        <path d="m9 15 3 3-3 3" />
    </svg>;
};
const VideoPlus = ({
    size = 16,
    color = "currentColor",
    ...props
}: {
    size?: number;
    color?: string;
    [key: string]: any;
}) => {
    return (
        <span className="ant-icon">
            <svg
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                stroke={color} // ← must use `color` prop, not hardcoded value
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                {...props}
            >
                <path d="M16 13L21.223 16.482C21.2983 16.5321 21.3858 16.5608 21.4761 16.5652C21.5664 16.5695 21.6563 16.5492 21.736 16.5065C21.8157 16.4639 21.8824 16.4003 21.9289 16.3228C21.9754 16.2452 22 16.1564 22 16.066V7.87C22 7.78202 21.9768 7.6956 21.9328 7.61945C21.8887 7.5433 21.8253 7.48012 21.7491 7.4363C21.6728 7.39248 21.5863 7.36956 21.4983 7.36985C21.4103 7.37015 21.324 7.39366 21.248 7.438L16 10.5" />
                <path d="M14 6H4C2.89543 6 2 6.89543 2 8V16C2 17.1046 2.89543 18 4 18H14C15.1046 18 16 17.1046 16 16V8C16 6.89543 15.1046 6 14 6Z" />
                <path d="M5.5 12H12.5" />
                <path d="M9 9.08333V14.9167" />
            </svg>
        </span>
    );
};

const FlipTriangle = () => {
    return (
        <svg width="8" height="8" viewBox="0 0 8 8" style={{ pointerEvents: "none" }}>
            <path d="M8 0 L8 8 L0 8 Z" fill="rgba(99,102,241,0.6)" />
        </svg>
    );
};

export {
    EyeOutlined,
    CheckOutlined,
    CloseOutlined,
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    EnvironmentOutlined,
    ArrowLeftOutlined,
    LockOutlined,
    UploadOutlined,
    DownOutlined,
    UpOutlined,
    UsergroupAddOutlined,
    HomeOutlined,
    SettingOutlined,
    LogoutOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    PlusOutlined,
    MinusOutlined,
    EditOutlined,
    DeleteOutlined,
    SearchOutlined,
    FilterOutlined,
    ReloadOutlined,
    FileOutlined,
    FolderOutlined,
    CameraOutlined,
    PictureOutlined,
    InfoCircleOutlined,
    WarningOutlined,
    ExclamationCircleOutlined,
    BellOutlined,
    CalendarOutlined,
    ClockCircleOutlined,
    CaretRightOutlined,
    Play,
    PlayOff,
    Pause,
    Autoplay,
    Replay,
    Bell,
    History,
    GitCompareArrow,
    VideoPlus,
    FlipTriangle,
};

export const LayoutDashboard = (props: any) => <Icon component={LayoutDashboardSvg} {...props} />;

export const LayoutTemplate = (props: any) => <Icon component={LayoutTemplateSvg} {...props} />;
